export const config = {
    facebookAppId: '121025258660432',
    // baseUrl: 'https://tona-new.nerdzlab.com',
    baseUrl: 'https://api.tona.fit',
    branchIOKey: 'key_live_ilHpDIjSXyUEmNe0trDJdffovFnsjFyq',
    branchIOSecret: 'secret_live_5KN8P31hFrJ0HPFeHesVPtyYGfZ1xLqV',
    branchIOAppId: '604284045811011861',
};



// WEBPACK FOOTER //
// ./src/Configurations/index.js